import React from 'react';

function Banner({bannerHeading, bannerContent, bannerIntro, bannerButton }) {
  return (
    <>
    <div className="section">
      
        <div className="banner sec-family">
        <h3>{bannerIntro}</h3>
          <h1>{bannerHeading}</h1>
          
              <p class="banner-p">{bannerContent}</p>
        <br></br>
        <button className="popular-item button-large">{bannerButton}</button>
<br></br>
<br></br>
<br></br>
        </div>
        
    </div>
    



    </>
  );
}

export default Banner;